import { NgModule } from "@angular/core";

import { ResidentToolbarModule } from "../../patient/resident-toolbar";
import { SharedModule } from "../../shared/shared.module";

import { TasksDetailComponent } from "./tasks-detail.component";
import { TasksDetailViewComponent } from "./detail-view/tasks-detail-view.component";
import { TasksUpdateFormComponent } from "./detail-view/form/tasks-update-form.component";
import { IonLabel } from "@ionic/angular/standalone";

@NgModule({
	imports: [SharedModule, ResidentToolbarModule, IonLabel],
	exports: [TasksDetailComponent, TasksDetailViewComponent, TasksUpdateFormComponent],
	declarations: [TasksDetailComponent, TasksDetailViewComponent, TasksUpdateFormComponent],
})
export class TasksDetailModule {}
